import './Loading.css'
function Loading () {
    return (
        <div className='container'>
            <img src="../photos/loading.gif" alt="loading..."></img>
        </div>
    );
}
export default Loading;